/**
 * Created by yibrahim on 20/07/2017.
 */
export class BrokenRule {
  constructor(public message: string = null) {}
}



// WEBPACK FOOTER //
// ./src/app/shared/models/broken-rule.ts